var Thread = /** @class */ (function () {
    function Thread() {
        this.isIdle = true;
    }
    Thread.prototype.do = function (job) {
        var _this = this;
        this.isIdle = false;
        return job.execute().finally(function () { return (_this.isIdle = true); });
    };
    return Thread;
}());
export default Thread;
